import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type RecoverPasswordMessages = SidebarMessages & {
  recoverPasswordTitle: string;
  recoverPasswordDescription: string;
  emailPlaceholder: string;
  emailLabel: string;
  errorRequiredEmail: string;
  errorInvalidEmail: string;
  recoverAction: string;
  cancelAction: string;
  temporaryPasswordSentTitle: string;
  temporaryPasswordSentDescription: string;
  goToLogin: string;
};

export const RECOVER_PASSWORD: RecoverPasswordMessages = {
  recoverPasswordTitle: "Recuperar senha",
  recoverPasswordDescription: "Insira seu email para recuperar sua senha.",
  emailPlaceholder: "Email",
  emailLabel: "Email",
  errorRequiredEmail: "Por favor, insira seu e-mail",
  errorInvalidEmail: "Email inválido",
  recoverAction: "Recuperar",
  cancelAction: "Cancelar",
  temporaryPasswordSentTitle: "Enviamos uma senha temporária para o seu email",
  temporaryPasswordSentDescription:
    "Confira seu e-mail para pegar sua senha temporária. Se você precisar solicitar uma nova senha, volte e selecione novamente a opção de 'Recuperar senha'.",
  goToLogin: "Voltar para tela de login",

  ...SIDEBAR_MESSAGES,
};

export default RECOVER_PASSWORD;
